var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.logs.data),function(log){return _c('RequestHistoryLogItem',{key:log.id,attrs:{"log":log}})}),_vm._v(" "),_c('pagination',{staticClass:"mt-3",attrs:{"data":_vm.logs,"limit":10},on:{"pagination-change-page":_vm.getResults}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }